import React, { useState, useEffect } from "react";
import "./style.scss";
import {
    COMPANY_REGISTER_ADDRESS,
    REGISTER_ADDRESS,
} from "../../../helperData/ApiAddress";
import { get, post } from "../../../controlers/global/ConfigRequest";
import { useTranslation } from "react-i18next";
import { COMPANY_REGISTER_TYPE_LIST } from "./../../../helperData/ApiAddress";
import i18n from "./../../../i18n/i18n";

export default function RegisterCompany({
    setMode,
    setActiveTab,
    setPhoneInit,
}) {
    const { t } = useTranslation();
    const [phone, setPhone] = React.useState("");
    const [phoneErr, setPhoneErr] = React.useState("");
    const [name, setName] = React.useState("");
    const [nameErr, setNameErr] = React.useState("");
    const [family, setFamily] = React.useState("");
    const [familyErr, setFamilyErr] = React.useState("");
    const [companyName, setCompanyName] = React.useState("");
    const [companyNameErr, setCompanyNameErr] = React.useState("");
    const [companyTypeValue, setCompanyTypeValue] = useState("-1");
    const [companyTypeValueErr, setCompanyTypeValueErr] = useState("");
    const [mail, setMail] = React.useState("");
    const [mailErr, setMailErr] = React.useState("");
    const [pass, setPass] = React.useState("");
    const [passErr, setPassErr] = React.useState("");
    const [pass2, setPass2] = React.useState("");
    const [pass2Err, setPass2Err] = React.useState("");

    const [companyTypes, setCompanyTypes] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [resultErr, setResultErr] = React.useState("");

    useEffect(() => {
        getCompanyType();
    }, []);

    const registerHandle = () => {
        let hasErr = false;
        let phoneStr;
        if (name.trim() === "") {
            setNameErr(t("Src.Component.Global.AuthModal.Register.setNameErr"));
            hasErr = true;
        }
        if (family.trim() === "") {
            setFamilyErr(
                t("Src.Component.Global.AuthModal.Register.setFamilyErr")
            );
            hasErr = true;
        }
        if (companyName === "") {
            setCompanyNameErr(t("Company.Register.CompanyName.Error"));
            hasErr = true;
        }
        if (companyTypeValue === "-1") {
            setCompanyTypeValueErr(t("Company.Register.CompanyType.Error"));
            hasErr = true;
        }
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Register.setPhoneErr")
                );
                hasErr = true;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Register.setPhoneErr")
                );
                hasErr = true;
            }
            phoneStr = "+98" + phone.substr(1);
        } else {
            setPhoneErr(
                t("Src.Component.Global.AuthModal.Register.setPhoneErr")
            );
            hasErr = true;
        }

        let patt = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

        if (!patt.test(mail)) {
            setMailErr(t("Src.Component.Global.AuthModal.Register.setMailErr"));
            hasErr = true;
        }

        if (pass.length < 8) {
            setPassErr(t("Src.Component.Global.AuthModal.Register.setPassErr"));
            hasErr = true;
        }
        if (pass !== pass2) {
            setPass2Err(
                t("Src.Component.Global.AuthModal.Register.setPass2Err")
            );
            hasErr = true;
        }
        if (hasErr === true) return false;
        setLoading(true);
        setResultErr("");
        post(COMPANY_REGISTER_ADDRESS, {
            user: {
                phone_number: phoneStr,
                first_name: name,
                last_name: family,
                email: mail,
                password: pass,
                username: phoneStr,
            },
            company: {
                name: companyName,
                category: companyTypeValue,
                email: mail,
            },
        })
            .then((r) => {
                setActiveTab(0);
                setMode(1);
                setPhoneInit(phoneStr);
                setLoading(false);
            })
            .catch((r) => {
                setLoading(false);
                if (r.response?.data.phone_number) {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.PhonesetResultErr"
                        )
                    );
                } else if (r.response?.data.non_field_errors) {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.EmailsetResultErr"
                        )
                    );
                } else {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.PhonesetResultErr"
                        ) || "Registration failed. Please try again."
                    );
                    console.log(r);
                }
            });
    };

    const nameHandle = (e) => {
        setName(e.target.value);
        setNameErr("");
    };

    const familyHandle = (e) => {
        setFamily(e.target.value);
        setFamilyErr("");
    };

    const companyNameHandle = (e) => {
        setCompanyName(e.target.value);
        setCompanyNameErr("");
    };
    const companyTypeHandle = (e) => {
        setCompanyTypeValue(e.target.value);
        setCompanyTypeValueErr("");
    };

    const phoneHandle = (e) => {
        let patt = new RegExp(/^\+?([0-9]*)$/);
        if (patt.test(e.target.value) || e.target.value === "") {
            setPhoneErr("");
            setPhone(e.target.value);
        }
    };

    const mailHandle = (e) => {
        setMailErr("");
        setMail(e.target.value);
    };

    const passHandle = (e) => {
        setPass(e.target.value);
        setPassErr("");
    };

    const pass2Handle = (e) => {
        setPass2(e.target.value);
        setPass2Err("");
    };

    const getCompanyType = () => {
        get(COMPANY_REGISTER_TYPE_LIST, { language: i18n.language }).then(
            (r) => {
                setCompanyTypes(r);
            }
        );
    };

    return (
        <>
            {/* <div className="auth-scroll-body"> */}
            <div className="register-container">
                <div className="input-form">
                    <div className="ri-input">
                        <label>{t("Company.Register.Admin.FristName")}</label>
                        <input
                            type="text"
                            placeholder={t("Name.Place.Holder")}
                            value={name}
                            onChange={nameHandle}
                            style={{ borderColor: nameErr && "orange" }}
                        />
                        {nameErr && (
                            <div className="login-form-err">{nameErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("Company.Register.Admin.LastName")}</label>
                        <input
                            type="text"
                            placeholder={t("LastName.Place.Holder")}
                            value={family}
                            onChange={familyHandle}
                            style={{ borderColor: familyErr && "orange" }}
                        />
                        {familyErr && (
                            <div className="login-form-err">{familyErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("Company.Register.CompanyName")}</label>
                        <input
                            type="text"
                            placeholder={t(
                                "Company.Register.CompanyName.Placeholder"
                            )}
                            value={companyName}
                            onChange={companyNameHandle}
                            style={{ borderColor: companyNameErr && "orange" }}
                        />
                        {companyNameErr && (
                            <div className="login-form-err">
                                {companyNameErr}
                            </div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("Company.Register.Company.Type")}</label>
                        <select
                            disabled={companyTypes.length === 0}
                            value={companyTypeValue}
                            onChange={companyTypeHandle}
                            style={{
                                borderColor: companyTypeValueErr && "orange",
                            }}
                        >
                            {companyTypes.length === 0 ? (
                                <option value="-1">
                                    {t("Src.Layouts.AppContent.MainPleaseWait")}
                                </option>
                            ) : (
                                <option value="-1">{t("form.choose")}</option>
                            )}
                            {companyTypes.map((companyType) => (
                                <option value={companyType.id}>
                                    {companyType.name}
                                </option>
                            ))}
                        </select>
                        {companyTypeValueErr && (
                            <div className="login-form-err">
                                {companyTypeValueErr}
                            </div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("PhoneNumber.Place.Holder")}</label>
                        <input
                            type="tel"
                            placeholder={t("PhoneNumber.Hint.Place.Holder")}
                            value={phone}
                            onChange={phoneHandle}
                            style={{ borderColor: phoneErr && "orange" }}
                        />
                        {phoneErr && (
                            <div className="login-form-err">{phoneErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("EmailAddress.Place.Holder")}</label>
                        <input
                            type="email"
                            placeholder={t("EmailAddress.Hint.Place.Holder")}
                            value={mail}
                            onChange={mailHandle}
                            style={{ borderColor: mailErr && "orange" }}
                        />
                        {mailErr && (
                            <div className="login-form-err">{mailErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("Password.Place.Holder")}</label>
                        <input
                            type="password"
                            placeholder={t(
                                "Password.Hint.Register.Place.Holder"
                            )}
                            value={pass}
                            onChange={passHandle}
                            style={{ borderColor: passErr && "orange" }}
                        />
                        {passErr && (
                            <div className="login-form-err">{passErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("RepeatPassword.Place.Holder")}</label>
                        <input
                            type="password"
                            placeholder={t("RepeatPassword.Hint.Place.Holder")}
                            value={pass2}
                            onChange={pass2Handle}
                            style={{ borderColor: pass2Err && "orange" }}
                        />
                        {pass2Err && (
                            <div className="login-form-err">{pass2Err}</div>
                        )}
                    </div>
                </div>
                <div className="ri-btn">
                    <button className="btn-st-1" onClick={registerHandle}>
                        {t("SignUp.Button")}
                    </button>
                    {/* <button onClick={handleClose} className="btn-st-2"><Google />ورود از طریق گوگل</button> */}
                    {loading && (
                        <div className="login-form-notif">
                            {t("Register.Loading")}
                        </div>
                    )}
                    {resultErr && (
                        <div className="login-form-err">{resultErr}</div>
                    )}
                </div>
            </div>
            {/* </div> */}
        </>
    );
}
